export var PostType;
(function (PostType) {
    PostType[PostType["BILL"] = 1] = "BILL";
    PostType[PostType["INVOICE"] = 2] = "INVOICE";
    PostType[PostType["CREDIT_RETURN"] = 3] = "CREDIT_RETURN";
    PostType[PostType["PAYMENT"] = 4] = "PAYMENT";
})(PostType || (PostType = {}));
//# sourceMappingURL=post-type.js.map